import { useEffect, useState } from "react";
import { collectionRef } from "@/api/firebase/collectionOperations";
import { useBrandsStore } from "@/store/brands/brands.store";
import { Brand } from "@/models/Brands.model";

export const useSingleBrand = (slug: string) => {
  const { brands, setBrands } = useBrandsStore();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const fetchData = async () => {
    setLoading(true);
    try {
      const querySnapshot = await collectionRef.Brands.where(
        "slug",
        "==",
        slug
      ).get();
      const data: Brand[] = [];
      querySnapshot.forEach((doc) => {
        const brandData = doc.data() as Omit<Brand, "slug">;
        const brand = {
          ...brandData,
          slug: doc.id,
        } as Brand;
        data.push(brand);
      });
      setBrands(data);
      setLoading(false);
    } catch (error) {
      setError(error as Error);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!brands || !brands.some((brand) => brand.slug === slug)) {
      fetchData();
    }
  }, [brands, slug]);

  return {
    data: brands?.find((brand) => brand.slug === slug) || null,
    loading,
    error,
  };
};
